import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { useState, useEffect, useRef } from 'react'

const getRandomVetMessage = () => {
  const messages = [
    "¿En qué puedo ayudar hoy?",
    //"Hola, soy Doctor Vet. ¿Listo para llevar tu veterinaria al siguiente nivel?",
    //"Hola, soy Doctor Vet. ¿Cómo te puedo ayudar a simplificar tu día de trabajo?",
  ];
  // const messages = [
  //   "¿Qué tal, doc? Soy Doctor Vet… con sombrero y todo. ¿Listo para llevar tu veterinaria al siguiente nivel?",
  //   "Guau… digo, ¡wow! ¿Sabías que tu clínica puede ser más organizada de lo que imaginas? Te cuento cómo.",
  //   "Un fedora no se lleva solo por estilo… también para cerrar buenos negocios. ¿Quieres escuchar la oferta?",
  //   "Dicen que el perro es el mejor amigo del hombre… pero yo quiero ser el mejor amigo de tu veterinaria.",
  //   "Por dónde quieres que empecemos hoy en tu veterinaria?",
  //   "¿Qué es lo que más te preocupa en este momento en tu clínica?",
  //   "¿Cómo te puedo ayudar a simplificar tu día de trabajo?",
  //   "¿Cuál es el mayor desafío que estás enfrentando con tu veterinaria ahora mismo?",
  //   "¿Hasta dónde quieres llegar con tu veterinaria?",
  //   "¿Te gustaría enfocarte más en crecer o en organizar lo que ya tienes?",
  //   "¿Cuál es tu meta más grande para tu veterinaria este año?",
  //   "A ver, jefe… ¿qué ladra más fuerte en tu veterinaria: la agenda, los cobros o los clientes?",
  //   "Contame: ¿querés más tiempo libre para pasear, o más clientes que entren por la puerta?",
  //   "¿Qué está tirando de tu correa en estos días: el desorden o la falta de crecimiento?",
  //   "Si me lanzás un hueso… digo, una pista, te muestro por dónde empezar."
  // ];
  return messages[Math.floor(Math.random() * messages.length)];
}


const ChatContent = ({ messages, current, message, setMessage, handleSendMessage, handleKeyPress, textareaRef, isLoading, isLoggedIn, userType, onUserTypeChange, onLoginClick, onOpenTerms }) => {
  const [randomMessage, setRandomMessage] = useState('')
  const messagesScrollRef = useRef(null)
  const messagesEndRef = useRef(null)

  useEffect(() => {
    setRandomMessage(getRandomVetMessage())
  }, [])

  useEffect(() => {
    const scrollToBottom = () => {
      const el = messagesScrollRef.current
      if (el) {
        el.scrollTop = el.scrollHeight
      }
      messagesEndRef.current?.scrollIntoView({ block: 'end', behavior: 'auto' })
    }
    const id = requestAnimationFrame(() => {
      requestAnimationFrame(scrollToBottom)
    })
    return () => cancelAnimationFrame(id)
  }, [messages, current, isLoading])

  return (
  <div className="flex min-h-0 flex-1 flex-col bg-white relative">
    {/* Barra superior con toggle de tipo de usuario y login */}
    <div className="absolute top-4 right-4 z-10 flex items-center gap-3">
      {userType && (
        <div className="flex items-center bg-gray-100 rounded-lg p-0.5">
          <button
            onClick={() => onUserTypeChange('NO_VET')}
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all duration-200 ${
              userType === 'NO_VET'
                ? 'bg-white text-gray-800 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            No veterinario
          </button>
          <button
            onClick={() => onUserTypeChange('VET')}
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all duration-200 ${
              userType === 'VET'
                ? 'bg-white text-gray-800 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            Veterinario
          </button>
        </div>
      )}

      {!isLoggedIn && (
        <button
          onClick={onLoginClick}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          Iniciar sesión
        </button>
      )}
    </div>
    {messages.length === 0 ? (
      /* Estado inicial - Todo centrado verticalmente */
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center px-4">
        <div className="max-w-2xl w-full">
          {/* Logo y título alineados horizontalmente */}
          <div className="flex items-center justify-center mb-8 gap-2">
            <img 
              src="./logotype.png" 
              alt="Doctor Vet Logo" 
              className="h-12 w-auto object-contain flex-shrink-0"
            />
            <h1 className="text-2xl font-normal text-gray-800 text-center">
              {randomMessage}
            </h1>
          </div>
          
          {/* Campo de entrada principal */}
          <div className="relative">
            <div className="flex items-end bg-gray-50 rounded-2xl border border-gray-200 focus-within:border-gray-300 transition-colors">
              {/* Botón de adjuntar */}
              {/*
              <button className="p-3 text-gray-400 hover:text-gray-600 transition-colors">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                </svg>
              </button>
              */}
              {/* Textarea */}
              <textarea
                ref={textareaRef}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Pregunta lo que quieras"
                className="flex-1 bg-transparent border-none outline-none resize-none py-3 pl-4 pr-2 text-gray-800 placeholder-gray-500 max-h-32"
                rows="1"
                style={{ minHeight: '20px' }}
                disabled={isLoading}
              />

              <div className="flex items-center p-2">
                {/* TODO: Botón de micrófono */}
                <button 
                  onClick={handleSendMessage}
                  disabled={!message.trim() || isLoading}
                  className={`p-2 rounded-lg transition-colors ${
                    message.trim() && !isLoading
                      ? 'bg-gray-800 text-white hover:bg-gray-700' 
                      : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                  }`}
                >
                  {isLoading ? (
                    <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  ) : (
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* Texto de términos */}
          <p className="text-xs text-gray-400 text-center mt-3">
            Al usar Doctor Vet IA aceptas los{' '}
            <button 
              onClick={onOpenTerms}
              className="text-gray-500 hover:text-gray-700 underline transition-colors"
            >
              Términos y Condiciones
            </button>
          </p>
        </div>
      </div>
    ) : (
      /* Estado con mensajes - Layout tradicional */
      <div className="flex min-h-0 flex-1 flex-col">
        {/* Área de mensajes */}
        <div ref={messagesScrollRef} className="min-h-0 flex-1 overflow-y-auto pb-8 pt-20">
          <div className="max-w-2xl mx-auto px-4">
            <div className="space-y-6">
              {messages.map((msg, index) => (
                <div key={index} className={`w-full ${msg.type === 'user' ? 'flex justify-end' : ''}`}>
                  <div className={`px-4 py-3 rounded-2xl ${
                    msg.type === 'user' 
                      ? 'bg-gray-100 text-gray-800 max-w-[85%]' 
                      : 'bg-white text-gray-800 w-full'
                  }`}>
                    {msg.type === 'assistant' ? (
                      <div className="prose prose-gray max-w-none">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                          {msg.content}
                        </ReactMarkdown>
                      </div>
                    ) : (
                      <div className="whitespace-pre-wrap">{msg.content}</div>
                    )}
                  </div>
                </div>
              ))}
              
              {/* Mostrar contenido streaming actual o cursor de carga */}
              {(current || isLoading) && (
                <div className="w-full">
                  <div className="px-4 py-3 rounded-2xl bg-white text-gray-800 w-full">
                    {current && (
                      <div className="prose prose-gray max-w-none">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                          {current}
                        </ReactMarkdown>
                      </div>
                    )}
                    <span className="inline-block w-2 h-4 bg-gray-400 ml-1 animate-pulse"></span>
                  </div>
                </div>
              )}
              <div ref={messagesEndRef} className="h-px w-full shrink-0" aria-hidden />
            </div>
          </div>
        </div>

        {/* Área de entrada fija abajo */}
        <div className="px-4 pb-8">
          <div className="max-w-2xl mx-auto">
            {/* Campo de entrada principal */}
            <div className="relative">
              <div className="flex items-end bg-gray-50 rounded-2xl border border-gray-200 focus-within:border-gray-300 transition-colors">
                {/* Botón de adjuntar */}
                {/*
                <button className="p-3 text-gray-400 hover:text-gray-600 transition-colors" disabled={isLoading}>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                  </svg>
                </button>
                */}

                {/* Textarea */}
                <textarea
                  ref={textareaRef}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="Pregunta lo que quieras"
                  className="flex-1 bg-transparent border-none outline-none resize-none py-3 pl-4 pr-2 text-gray-800 placeholder-gray-500 max-h-32"
                  rows="1"
                  style={{ minHeight: '20px' }}
                  disabled={isLoading}
                />

                {/* Botón de micrófono y enviar */}
                <div className="flex items-center p-2">
                  {/* TODO: Botón de micrófono */}
                  <button 
                    onClick={handleSendMessage}
                    disabled={!message.trim() || isLoading}
                    className={`p-2 rounded-lg transition-colors ${
                      message.trim() && !isLoading
                        ? 'bg-gray-800 text-white hover:bg-gray-700' 
                        : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                    }`}
                  >
                    {isLoading ? (
                      <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                    ) : (
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* Texto de términos */}
            <p className="text-xs text-gray-400 text-center mt-3">
              Al usar Doctor Vet IA aceptas los{' '}
              <button 
                onClick={onOpenTerms}
                className="text-gray-500 hover:text-gray-700 underline transition-colors"
              >
                Términos y Condiciones
              </button>
            </p>
          </div>
        </div>
      </div>
    )}
  </div>
  )
}

export default ChatContent
